import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { NotificationManager } from 'react-notifications';
import { useMsal } from '@azure/msal-react';
import useFetchSensorStatuses from './useFetchSensorStatuses';
import { msalConfig } from '../auth/authConfig';
import { errorHandler } from '../utils/helpers';
import useUserStore from '../store/userStore';
import { acquireToken } from '../utils/auth';

interface DeleteSensorStatusRequest {
  id: string | number;
  token: string | null;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
  fetchSensorsStatuses: () => any;
  userId: string | number;
};

const deleteSensorStatusRequest = async ({
    token,
    setError,
    setLoading,
    fetchSensorsStatuses,
    id,
    userId,
  }: DeleteSensorStatusRequest) => {
  try {
    const response = await axios.delete(`${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Sensor/Status/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
        userId,
      },
    });
    if (response.status === 200) {
      NotificationManager.success('Sensor Status is successfully deleted');
    }
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    fetchSensorsStatuses();
    setLoading(false);
  }
};

interface DeleteSensorStatus {
  deleteSensorStatus: (id: string | number) => void;
  loading: boolean;
  error: Error | null;
};

const useDeleteSensorStatus = (): DeleteSensorStatus => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const { fetchSensorsStatuses } = useFetchSensorStatuses();
  
  const { user } = useUserStore();

  const deleteSensorStatus = async (id) => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };

      if (!user) return navigate('/sign-in');

      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        deleteSensorStatusRequest({
          id,
          token: accessToken,
          setError,
          fetchSensorsStatuses,
          setLoading,
          userId: user.id,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { deleteSensorStatus, loading, error };
};

export default useDeleteSensorStatus;
